/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c2370ad8f2d629cac1adc2a88058b4>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "TextIndentRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-indent-right
 * Usage guidance:
 * Single purpose - Reserved for shifting the indent of text content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const TextIndentRightIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "TextIndentRightIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zM2.03 4.72l2.75 2.75a.75.75 0 0 1 0 1.06l-2.75 2.75-1.06-1.06L3.19 8 .97 5.78zM15 6.667H8v-1.5h7zm0 4.166H8v-1.5h7zm0 2.667V15H1v-1.5z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
TextIndentRightIcon.displayName = 'TextIndentRightIcon';
var _default = exports.default = TextIndentRightIcon;